import { getApp, getApps, initializeApp } from "firebase/app";
import {
  MessagePayload,
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";

import localforage from "localforage";

const verbose = !false;
function verboseLog(...args: any[]) {
  if (verbose && process.env.NODE_ENV === "development") {
    console.log(args.join(" "));
  }
}

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const app = !getApps()?.length ? initializeApp(firebaseConfig) : getApp();

const firebaseCloudMessaging = {
  tokenInlocalforage: async () => {
    const token = await localforage.getItem("fcm_token");
    verboseLog("[FCM] fcm_token tokenInlocalforage", token);
    return token;
  },

  deleteTokenFromLocalForage: async () => {
    verboseLog("[FCM] deleteTokenFromLocalForage");
    return localforage.removeItem("fcm_token");
  },

  onMessage: async (onMessageCb: (payload: MessagePayload) => void) => {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      if (!payload.notification) {
        return;
      }
      verboseLog("[FCM] Message received. ", payload);
      onMessageCb(payload);
    });
  },

  init: async function () {
    try {
      if (!("serviceWorker" in navigator)) {
        console.log("Service workers are not supported");
        return false;
      }

      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
        {
          scope: "/",
        },
      );
      verboseLog("[FCM] Service Worker registered", registration);

      const tokenFromStorage = await this.tokenInlocalforage();
      if (tokenFromStorage !== null) {
        verboseLog("[FCM] Token already exists");
        return false;
      }

      if (Notification.permission === "denied") {
        verboseLog("[FCM] Notifications are denied");
        return false;
      }

      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          verboseLog("[FCM] Permission not granted");
          return false;
        }
      }

      verboseLog("[FCM] Creating token.");
      const messaging = getMessaging(app);

      const currentToken = await getToken(messaging, {
        vapidKey: process.env.NEXT_PUBLIC_FIREBASE_WEB_PUSH_KEY,
        serviceWorkerRegistration: registration,
      }).catch((err) => {
        verboseLog(
          `NOTIFICATION An error occurred while retrieving token. ${err}`,
        );
        return null;
      });

      if (!currentToken) {
        verboseLog("[FCM] No registration token available.");
        return false;
      }

      await localforage.setItem("fcm_token", currentToken);
      verboseLog("[FCM] fcm_token", currentToken);
      return true;
    } catch (error) {
      console.error("[FCM] Error initializing:", error);
      return false;
    }
  },
};

export { firebaseCloudMessaging };
